<template>
    <div class="mb-2">
        <div v-for="(choice, index) in choices" class="d-flex flex-wrap justify-content-center" :key="index">
            <div class="pb-2">
                <badge-pill :text="choice"/>
            </div>
        </div>
    </div>
</template>

<script>
import BadgePill from "../../atoms/BadgePill";
export default {
    name: "UserChoices",
    components: {BadgePill},
    props:{
        choices:{
            type: Array,
            required: true
        }
    }
}
</script>
